// import { PipesModule } from '@a2system/angular/common';
import { LayoutModule } from '@angular/cdk/layout';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'app/src/environments/environment';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ApiServerModule, MaterialModule } from '@a2system/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { FirebaseUIModule } from 'firebaseui-angular';
import { initializeApp } from '@angular/fire/app';
import { provideFirebaseApp } from '@angular/fire/app';
import { getFirestore } from '@angular/fire/firestore';
import { provideFirestore } from '@angular/fire/firestore';
import { firebaseUiAuthConfig } from './core/settings/auth-settings';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function firebaseAppNameFactory() {
  return `client`;
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    NgxPermissionsModule.forRoot(),
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    MaterialModule,
    TranslateModule.forRoot({
      defaultLanguage: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
    provideFunctions(() => {
      const functions = getFunctions(undefined, 'europe-west1');
      return functions;
    }),

    FirebaseUIModule.forRoot(firebaseUiAuthConfig),
    ApiServerModule.forRoot(environment.apiServer),
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    { provide: FIREBASE_OPTIONS, useValue: environment.firebaseConfig },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
